module.exports = __webpack_public_path__ + "img/ic_dial_white.1a737cd8.svg";